/*@flow*/
import { createContext } from 'react';

export default (createContext<{ user_can_see_private_data: boolean }, *>({
  user_can_see_private_data: true,
}): React$Context<{user_can_see_private_data: boolean, ...}>);
